import React from "react";
import "../Style/Heroo.css";
import { FiArrowUpRight, FiPhone, FiChevronDown } from "react-icons/fi";
import heroVideo from "../assets/bggg.mp4"; // uploaded clip, used as-is
import logoImg from "../assets/Vector.png"; // TODO: point this at your actual logo file

// Two explicit lines so the headline always breaks the same way,
// regardless of container width.
const headingLines = [
  [
    { text: "Custom", accent: false },
    { text: "software", accent: false },
    { text: "that", accent: false },
    { text: "moves", accent: true },
  ],
  [
    { text: "your", accent: false },
    { text: "business", accent: false },
    { text: "forward.", accent: false },
  ],
];

const descriptionLines = [
  "From UI/UX design to custom software development,",
  "mobile apps, SaaS platforms, and websites — MPeoples",
  "helps businesses turn ideas into scalable digital products.",
];

// startAnimation: controls whether Hero's entrance timeline is allowed to
// play. Hero is always mounted in the DOM (so layout/order is stable and
// Homepage never appears "first"); while startAnimation is false, all of
// Hero's entrance animations are frozen at frame 0 via CSS
// (animation-play-state: paused), so the section sits there with its own
// curtain closed until the parent says "go".
function Hero({ startAnimation = true }) {
  return (
    <section className={`home${startAnimation ? "" : " home--paused"}`}>
      {/* Split curtain — opens first, revealing the video underneath */}
      <div className="hero-curtain hero-curtain--top" aria-hidden="true" />
      <div className="hero-curtain hero-curtain--bottom" aria-hidden="true" />

      <video
        className="hero-bg-video"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={heroVideo} type="video/mp4" />
      </video>

      <div className="hero-grade" />
      <div className="hero-vignette" />
      <div className="hero-grain" />
      <div className="home-glow home-glow--1" />
      <div className="home-glow home-glow--2" />

      <div className="home-container">
        <div className="hero-logo">
          <img src={logoImg} alt="MPeoples" className="hero-logo-img" />
        </div>

        <h1 className="main-heading">
          {headingLines.map((line, li) => (
            <span className="heading-line" key={li}>
              {line.map((word, wi) => {
                const globalIndex =
                  li === 0 ? wi : headingLines[0].length + wi;
                return (
                  <span
                    key={wi}
                    className={`heading-word${
                      word.accent ? " accent" : ""
                    }`}
                    style={{ animationDelay: `${1.75 + globalIndex * 0.07}s` }}
                  >
                    {word.text}&nbsp;
                  </span>
                );
              })}
            </span>
          ))}
        </h1>

        <p className="description">
          {descriptionLines.map((line, i) => (
            <span
              className="desc-line"
              key={i}
              style={{ animationDelay: `${2.55 + i * 0.1}s` }}
            >
              {line}
            </span>
          ))}
        </p>

        <div className="button-group">
          <a href="#contactsec" className="btn-link">
            <button className="btn primary-btn">
              <span className="btn-shine" />
              Start your project <FiArrowUpRight className="icon" />
            </button>
          </a>

          
           <a href="tel:+919876543210"
            className="btn-link"
            style={{ textDecoration: "none" }}
          >
            <button className="btn secondary-btn">
              Book a free call <FiPhone className="icon" />
            </button>
          </a>
        </div>
      </div>

      <div className="scroll-cue">
        <span className="scroll-cue-track">
          <span className="scroll-cue-dot" />
        </span>
        <FiChevronDown className="scroll-cue-arrow" />
      </div>
    </section>
  );
}

export default Hero;